"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscribeTemplate = void 0;
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const translation_1 = require("@translation/services/translation");
const form_1 = require("@common/subscription/form");
const subscription_1 = require("@common/services/subscription");
/**
 * Всплывающее окно подписки
 */
let SubscribePopup = class SubscribePopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Успешная отправка
         */
        this.success = false;
        /**
         * Тип содержимого
         */
        this.type = 'default';
        /**
         * Параметры окна
         */
        this.params = {};
        /**
         * Форма
         */
        this.form = new control_1.Form({
            password: new control_1.TextControl(''),
            repeatPassword: new control_1.TextControl(''),
        });
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.subscriptionService = typedi_1.Container.get(subscription_1.SubscriptionService);
        this.subscribed = this.subscribed.bind(this);
    }
    /**
     * Возвращает заголовок
     */
    get header() {
        switch (this.type) {
            case 'gettrafic':
                return this.translationService.instant('get_web_traffic');
            case 'getcredibility':
                return this.translationService.instant('get_consumers_credibility');
            default:
                return this.translationService.instant('turn_your_art_into_money');
        }
    }
    /**
     * Возвращает описание
     */
    get description() {
        switch (this.type) {
            case 'gettrafic':
                return this.translationService.instant('since_the_relevance_of_words');
            case 'getcredibility':
                return this.translationService.instant('art_is_the_ultimate_digital_signifier');
            default:
                return this.translationService.instant('when_you_buy_a_art_domain');
        }
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        this.type = this.params.type || 'default';
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body pt-5 py-7">
                            <button class="btn--back js-btn-close" data-bs-dismiss="modal">
                                <span class="header--xs">${this.translationService.instant('av_back')}</span>
                            </button>
                            <div class="mt-5 mb-5">
                                <h2 class="mb-5">${this.header}</h2>
                                <p>${this.description}</p>
                            </div>

                            ${this.success
            ? (0, lit_html_1.html) `
                                    <h2 class="mt-5">${this.translationService.instant('aa_thxforjoin')}</h2>
                                ` : (0, lit_html_1.html) `
                                     <h3>${this.translationService.instant('type_in_your_email')}</h3>

                                     ${(0, form_1.getSubscriptionTemplate)(this.subscriptionService, this.translationService, this.subscribed)}
                                `}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Обрабатывает успешную подписку
     */
    subscribed() {
        this.success = true;
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], SubscribePopup.prototype, "success", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], SubscribePopup.prototype, "params", void 0);
SubscribePopup = __decorate([
    (0, decorators_js_1.customElement)('art-subscribe-popup'),
    __metadata("design:paramtypes", [])
], SubscribePopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getSubscribeTemplate(params) {
    return (0, lit_html_1.html) `<art-subscribe-popup .params="${params}"></art-subscribe-popup>`;
}
exports.getSubscribeTemplate = getSubscribeTemplate;
window.PopupController.registerTemplate('subscribe', getSubscribeTemplate);
